import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { authApi } from '../store/auth/authApi';
import { userAPI } from '../store/user/userApi';
import { userDomAPI } from '../store/user/userDomApi';
import teamsSlice from '../store/brokers/partners/teams/teamsSlice';
import partnersSlice from '../store/brokers/partners/partners/partnersSlice';
import documentsSlice from '../store/brokers/partners/documents/documentsSlice';
import activitiesSlice from '../store/brokers/partners/activities/activititesSlice';
import historyChatsSlice from '../store/brokers/partners/history-chats/historyChatsSlice';
import userAccessSlice from '../store/brokers/partners/user-access-control/userAccessSlice';
import notificationsSlice from '../store/brokers/partners/notifications/notificationsSlice';
import knowledgeFilesSlice from '../store/brokers/partners/knowledge-files/knowledgeFilesSlice';
import questionsSlice from '../store/brokers/partners/unanswered-questions/unansweredQuestionsSlice';
import brandingConfigReducer from '../store/brokers/partners/branding/BrandingSlice'; // <--- default import, NOT { brandingConfigSlice }
import { chatboxApi } from '../store/chatbox/chatboxApi';
import { ttsApi } from '../store/chatbox/ttsApi';
import { knowledgeFilesAiServiceSlice } from '../store/brokers/partners/knowledge-files-ai-service/knowledgeFilesSlice';

export const store = configureStore({
    reducer: {
        [userAPI.reducerPath]: userAPI.reducer,
        [authApi.reducerPath]: authApi.reducer,
        [userDomAPI.reducerPath]: userDomAPI.reducer,
		[chatboxApi.reducerPath]: chatboxApi.reducer,
		[ttsApi.reducerPath]: ttsApi.reducer,
        userAccess: userAccessSlice,
        partners: partnersSlice,
        history: historyChatsSlice,
        branding: brandingConfigReducer, // <--- Use the reducer, not the slice object
        teams: teamsSlice,
        notifications: notificationsSlice,
        activities: activitiesSlice,
        questions: questionsSlice,
        documents: documentsSlice,
        knowledgeFiles: knowledgeFilesSlice,
        knowledgeFilesAiService: knowledgeFilesAiServiceSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            userAPI.middleware,
            authApi.middleware,
            userDomAPI.middleware,
			chatboxApi.middleware,
			ttsApi.middleware
        ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
